import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const categories = [
  { path: "security", label: "Security" },
  { path: "communication", label: "Communication" },
  { path: "displays", label: "Displays" },
  { path: "solutions", label: "Solutions" },
  { path: "computers", label: "Computers" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // For dropdown menu
  const [isBurgerOpen, setIsBurgerOpen] = useState(false); // For burger menu

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const toggleBurgerMenu = () => {
    setIsBurgerOpen((prev) => !prev);
  };

  // Close the burger menu when any link is clicked
  const handleLinkClick = () => {
    setIsBurgerOpen(false);
    setIsOpen(false); // Close dropdown if open
  };

  return (
    <div className="navbar-container">
      <nav className="navbar-content">
        {/* Left Section: Logo */}
        <div className="logo-section">
          <Link to="/" className="logo-text">
            Sree Sai Electronics<span className="logo-highlight">.</span>
          </Link>
        </div>

        {/* Hamburger Icon */}
        <button onClick={toggleBurgerMenu} className="hamburger">
          <svg
            className="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isBurgerOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            )}
          </svg>
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isBurgerOpen ? "show" : ""}`}>
          <li className="nav-item">
            <Link to="/home" className="nav-link" onClick={handleLinkClick}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <button className="nav-link dropdown-toggle" onClick={toggleDropdown}>
              Services
            </button>
            {isOpen && (
              <ul className="dropdown-menu" onMouseLeave={closeDropdown}>
                {categories.map((category) => (
                  <li key={category.path}>
                    <Link
                      to={`/services/${category.path}`}
                      className="dropdown-item"
                      onClick={() => {
                        closeDropdown();
                        handleLinkClick();
                      }}
                    >
                      {category.label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li className="nav-item">
            <Link to="/contactUs" className="nav-link" onClick={handleLinkClick}>
              Contact Us
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
